import type { ViewIds } from '@ardoq/api-types';
import { actionCreator, dispatchAction } from '@ardoq/rxbeach';
import type { UrlFieldValue } from './types';

export const urlClicked = actionCreator<{
  url: string;
  viewId: ViewIds | null;
}>('[graph] URL_CLICKED');

/**
 * A URL icon opens its URL directly only when the item has exactly one;
 * with several, the icon's popover lists them instead.
 */
export const maybeDispatchUrlIconClick = (
  urlFieldValues: UrlFieldValue[] | null | undefined,
  viewId: ViewIds | null
) => {
  if (urlFieldValues?.length !== 1) {
    return;
  }
  dispatchAction(urlClicked({ url: urlFieldValues[0].url, viewId }));
};
